import http from "@/services/http";

export async function fetch() {
  const { data } = await http().get(window.env.COMMERCE_API + "/countries");
  return data.countries;
}
